import React, { useState, useEffect } from "react";
import Book from "./Book";
import { backendBookartUrl } from "../library/constants";
import axios from "axios";
import DownloadXlsFile from "../components/DownloadXlsFile";

const AllBookTemplate = (props) => {
  const [products, setProducts] = useState([]);
  const [backupProducts, setBackupProducts] = useState([]);
  const [isAllBooks] = useState(props.is_allBooks || false);
  const [pageSize] = useState(5);
  const [pager, setPager] = useState({});
  const [pageOfItems, setPageOfItems] = useState([]);
  const [subjectArea, setSubjectArea] = useState("");
  const [subSubjectArea, setSubSubjectArea] = useState("");
  const [totalFilters, setTotalFilters] = useState(0);
  const [subjectAreaArray, setSubjectAreaArray] = useState([]);
  const [subSubjectAreaArray, setSubSubjectAreaArray] = useState([]);
  const [toggle, setToggle] = useState(true);
  const [toggleSubSubject, setToggleSubSubject] = useState(true);
  const [toggleFilter, setToggleFilter] = useState(true);
  const [filterLabel, setFilterLabel] = useState("");
  const [ariaLabel, setAriaLabel] = useState(false);

  const setPage = (page) => {
    const items = products;
    const pager = getPager(items.length, page, pageSize);
    const pageOfItems = items.slice(pager.startIndex, pager.endIndex + 1);
    setPager(pager);
    setPageOfItems(pageOfItems);
    window.location = "#"; // To scroll the page to top
  };

  const getPager = (totalItems, currentPage = 1, pageSize = 10) => {
    const totalPages = Math.ceil(totalItems / pageSize);
    let startPage, endPage;
    if (totalPages <= 10) {
      startPage = 1;
      endPage = totalPages;
    } else {
      if (currentPage <= 6) {
        startPage = 1;
        endPage = 10;
      } else if (currentPage + 4 >= totalPages) {
        startPage = totalPages - 9;
        endPage = totalPages;
      } else {
        startPage = currentPage - 5;
        endPage = currentPage + 4;
      }
    }

    const startIndex = (currentPage - 1) * pageSize;
    const endIndex = Math.min(startIndex + pageSize - 1, totalItems - 1);
    const pages = [...Array(endPage + 1 - startPage).keys()].map((i) => startPage + i);

    return {
      totalItems,
      currentPage,
      pageSize,
      totalPages,
      startPage,
      endPage,
      startIndex,
      endIndex,
      pages,
    };
  };

  const fetchSubjectArea = () => {
    const token = window.sessionStorage.getItem("JWTtoken");
    const config = {
      method: "post",
      url: `${backendBookartUrl}/all_stream?=`,
      headers: {
        "Authorization": `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };
    axios(config)
      .then((response) => {
        const uniqueChars = [...new Set(response.data.subjects)];
        setSubjectAreaArray(uniqueChars);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleChangeSubjectArea = (event) => {
    event.preventDefault();
    const subjectArea = event.target.value;
    setSubjectArea(subjectArea);
    setTotalFilters(1);
    setSubSubjectAreaArray([]);
    setSubSubjectArea("");
    setProducts(backupProducts);
    setToggle(!toggle);
    if (subjectArea !== "") {
      handleFiltering();
      const token = window.sessionStorage.getItem("JWTtoken");
      const data = JSON.stringify({ stream_text: subjectArea });
      const config = {
        method: 'post',
        url: `${backendBookartUrl}/subjects_by_stream?=`,
        headers: {
          "Authorization": `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        data: data
      };
      axios(config)
        .then((response) => {
          const uniqueChars = [...new Set(response.data.all_relevant_subject)];
          setSubSubjectAreaArray(uniqueChars);
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      setPage(1);
    }
  };

  const handleChangeSubSubjectArea = (event) => {
    event.preventDefault();
    const subSubjectArea = event.target.value;
    setSubSubjectArea(subSubjectArea);
    setTotalFilters(2);
    setToggleSubSubject(!toggleSubSubject);
    handleFiltering();
  };

  const handleFiltering = () => {
    let filteredProducts = backupProducts;
    if (subjectArea !== "") {
      filteredProducts = filteredProducts.filter((element) => element.stream === subjectArea);
      if (subSubjectArea !== "") {
        filteredProducts = filteredProducts.filter((element) => element.subject === subSubjectArea);
      }
    }
    setProducts(filteredProducts);
    setPage(1);
  };

  useEffect(() => {
    handleFiltering();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [subjectArea, subSubjectArea]);

  const handleSorting = (event) => {
    event.preventDefault();
    const sortBy = event.target.value;
    const filterLabelId = event.target.id;
    let sortedProducts = [...products];
    switch (sortBy) {
      case "year-desc":
        sortedProducts.sort((a, b) => b.year - a.year); // Sort by year descending
        break;
      case "year-asc":
        sortedProducts.sort((a, b) => a.year - b.year); // Sort by year ascending
        break;
      case "title-desc":
        sortedProducts.sort((a, b) => a.title.localeCompare(b.title, undefined, { sensitivity: 'base' }) * -1); // Sort by title descending
        break;
      case "title-asc":
        sortedProducts.sort((a, b) => a.title.localeCompare(b.title, undefined, { sensitivity: 'base' })); // Sort by title ascending
        break;
      default:
        break;
    }
    setProducts(sortedProducts);
    setToggleFilter(!toggleFilter);
    setFilterLabel(filterLabelId);
    setPage(1);
  };

  // const downloadAllBooks = () => {
  //   axios.post(`${backendBookartUrl}/allbooks`, { search_value: "all_products" })
  //     .then((response) => {
  //       const products = response.data.products;
  //       // Handle download logic here
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //     });
  // };

  const toggleHidden = () => {
    setToggle(!toggle);
  };

  const toggleSubSubjectHidden = () => {
    setToggleSubSubject(!toggleSubSubject);
  };

  const toggleFiltering = () => {
    setToggleFilter(!toggleFilter);
  };

  const toggleMobile = () => {
    setAriaLabel(!ariaLabel);
  };

  useEffect(() => {
    if (products.length > 0) {
      setPage(1);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [products]);

  useEffect(() => {
    const cleanedData = props.data.map((el) => el) || [];
    setProducts(cleanedData);
    setBackupProducts(cleanedData);
    if (cleanedData.length > 0) {
      setPage(1);
    }
    fetchSubjectArea();

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.data]);

  return (
    <React.Fragment>
      <div className="container-allbooks">
        <section id="book-details" className="all-book-template">
          <div className="row row-body">
            <div className="col-md-3 side-filter">
              <div className="counter-box">
                <div className="filter">
                  <h1>Filters</h1> <h2 className="filter-counter">{totalFilters}</h2>
                </div>
                {subjectArea !== "" && subSubjectArea !== "" && (
                  <span
                    className="clear-all-tag"
                    onClick={() => {
                      setSubjectArea("");
                      setSubSubjectArea("");
                      setTotalFilters(0);
                      setProducts(products);
                      handleFiltering();
                    }}
                  >
                    Clear all
                  </span>
                )}
              </div>
              <h5>Subject Areas</h5>
              <div className="dropdown-main">
                <button onClick={toggleHidden} className="dropdown-button" id="button">
                  <span>{subjectArea ? subjectArea.split(" ")[0] : "All Subject area".substring(0, 25)}</span>
                  <svg className={toggle ? "arrow-down-svg" : "arrow-up-svg"} width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path className={toggle ? "" : "arrow-up-svg-color"} d="M0 1.23529L1.23529 0L7.94118 6.70588L14.6471 0L15.8824 1.23529L7.94118 9.17647L0 1.23529Z" fill="#007398" />
                  </svg>
                </button>
                <div className={toggle ? "dropdown-container dropdown-container-hidden" : "dropdown-container"}>
                  <div key="all subject Area" className="dropdown-items">
                    <label className="select-item no-input" htmlFor="no-input">All subject Area</label>
                    <input onClick={handleChangeSubjectArea} className="dropdwn-option" id="no-input" type="radio" value="" />
                  </div>
                  {subjectAreaArray.map((element) => (
                    <div key={element} className="dropdown-items">
                      <label className="select-item" htmlFor={`select-${element}`}>{element}</label>
                      <input onClick={handleChangeSubjectArea} className="dropdwn-option" id={`select-${element}`} type="radio" value={element} />
                    </div>
                  ))}
                </div>
              </div>

              {subjectArea !== "" && (
                <div className="dropdown-main">
                  <button onClick={toggleSubSubjectHidden} className="dropdown-button" id="button">
                    <span>{subSubjectArea ? subSubjectArea.split(" ")[0] : "All related subject area".substring(0, 15)}</span>
                    <svg className={toggleSubSubject ? "arrow-down-svg" : "arrow-up-svg"} width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path className={toggleSubSubject ? "" : "arrow-up-svg-color"} d="M0 1.23529L1.23529 0L7.94118 6.70588L14.6471 0L15.8824 1.23529L7.94118 9.17647L0 1.23529Z" fill="#007398" />
                    </svg>
                  </button>
                  <div className={toggleSubSubject ? "dropdown-container dropdown-container-hidden" : "dropdown-container"}>
                    {subSubjectAreaArray.map((element) => (
                      <div key={element} className="dropdown-items">
                        <label className="select-item" htmlFor={`select-${element} ${element}`}>{element}</label>
                        <input onClick={handleChangeSubSubjectArea} className="dropdwn-option" id={`select-${element} ${element}`} type="radio" value={element} />
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
            <div className="col-md-9 book-details-side">
              {subjectArea !== "" && (
                <button
                  className="es-tag display-none"
                  onClick={() => {
                    setSubjectArea("");
                    setSubSubjectArea("");
                    setProducts(backupProducts);
                    setTotalFilters(0);
                    handleFiltering();
                  }}
                >
                  <span>{subjectArea}</span>
                  <svg viewBox="0 0 70 128" height="24" width="14">
                    <path d="M68.94 36.12L62 29 35 56 8 29l-7 7 27 27L1 90l7 7 27-27 27 27 7-7-27-27 26.94-26.88" />
                  </svg>
                </button>
              )}
              {subSubjectArea !== "" && (
                <button
                  className="es-tag display-none"
                  onClick={() => {
                    setSubSubjectArea("");
                    setProducts(backupProducts);
                    setTotalFilters(1);
                    handleFiltering();
                  }}
                >
                  <span>{subSubjectArea}</span>
                  <svg viewBox="0 0 70 128" height="24" width="14">
                    <path d="M68.94 36.12L62 29 35 56 8 29l -7 7 27 27L1 90l7 7 27-27 27 27 7-7-27-27 26.94-26.88" />
                  </svg>
                </button>
              )}
              {products.length !== 0 ? (
                <div>
                  {subjectArea !== "" && <hr className="line-break" />}
                  <div className="row column-side-head">
                    <div className="col-md-4 padding-top-10">
                      {pager.totalItems} results, showing{" "}
                      {pager.startIndex + 1}-{pager.endIndex + 1}
                    </div>
                    <div className="filter-button">
                      <ul>
                        <li className="es-header-icons-item es-header-icons-mobile">
                          <button
                            aria-controls="es-id-header"
                            aria-label="More"
                            className="filter-button-mobile es-header-icons-button es-js-tooltip es-js-popup"
                            aria-expanded={ariaLabel}
                            onClick={toggleMobile}
                          >
                            filter
                          </button>
                        </li>
                      </ul>
                      <div
                        aria-label="Account, links and setting"
                        className="es-header-side es-js-sidebar"
                        hidden={!ariaLabel}
                        id="es-id-header"
                        role="dialog"
                      >
                        <div className="es-header-side-content">
                          <svg
                            className="pointer right-float"
                            onClick={toggleMobile}
                            viewBox="0 0 70 128"
                            height="24"
                            width="14"
                          >
                            <path d="M68.94 36.12L62 29 35 56 8 29l-7 7 27 27L1 90l7 7 27-27 27 27 7-7-27-27 26.94-26.88"></path>
                          </svg>
                          <div className="col-md-8">
                            <div className="row horizontal-container">
                              <div className={isAllBooks ? "col-md-4 text-end auto-width" : "col-md-6 text-end auto-width"}>
                                <label> Sort by:</label>
                              </div>
                              <div className="dropdown-main dropdown-horizontal sortby-mobile">
                                <button onClick={toggleFiltering} className="dropdown-button" id="button">
                                  <span>{filterLabel ? filterLabel : "Sort By"}</span>
                                  <svg className={toggleFilter ? "arrow-down-svg" : "arrow-up-svg"} width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path className={toggleFilter ? "" : "arrow-up-svg-color"} d="M0 1.23529L1.23529 0L7.94118 6.70588L14.6471 0L15.8824 1.23529L7.94118 9.17647L0 1.23529Z" fill="#007398" />
                                  </svg>
                                </button>
                                <div className={toggleFilter ? "dropdown-container fixed-dropdown dropdown-container-hidden" : "dropdown-container fixed-dropdown"}>
                                  <div key="latest" className="dropdown-items">
                                    <label className="select-item no-input pointer" htmlFor="Publication(Latest)">Publication(Latest)</label>
                                    <input onClick={handleSorting} className="dropdwn-option" id="Publication(Latest)" type="radio" value="year-desc" />
                                  </div>
                                  <div key="oldest" className="dropdown-items">
                                    <label className="select-item no-input pointer" htmlFor="Publication(Oldest)">Publication(Oldest)</label>
                                    <input onClick={handleSorting} className="dropdwn-option" id="Publication(Oldest)" type="radio" value="year-asc" />
                                  </div>
                                  <div key="correct-order" className="dropdown-items">
                                    <label className="select-item no-input pointer" htmlFor="Alphabetical(A-Z)">Alphabetical(A-Z)</label>
                                    <input onClick={handleSorting} className="dropdwn-option" id="Alphabetical(A-Z)" type="radio" value="title-asc" />
                                  </div>
                                  <div key="reverse-order" className="dropdown-items">
                                    <label className="select-item no-input pointer" htmlFor="Alphabetical(Z-A)">Alphabetical(Z-A)</label>
                                    <input onClick={handleSorting} className="dropdwn-option" id="Alphabetical(Z-A)" type="radio" value="title-desc" />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="col-md-3">
                            <div className="counter-box">
                              <div className="filter">
                                <h1>Filters</h1> <h2 className="filter-counter">{totalFilters}</h2>
                              </div>
                              {subjectArea !== "" && subSubjectArea !== "" && (
                                <span
                                  className="clear-all-tag"
                                  onClick={() => {
                                    setSubjectArea("");
                                    setSubSubjectArea("");
                                    setTotalFilters(0);
                                    setProducts(backupProducts);
                                    handleFiltering();
                                  }}
                                >
                                  Clear all
                                </span>
                              )}
                            </div>
                            <h5>Subject Areas</h5>
                            <div className="dropdown-main">
                              <button onClick={toggleHidden} className="dropdown-button" id="button">
                                <span>{subjectArea ? subjectArea.split(" ")[0] : "All Subject area".substring(0, 25)}</span>
                                <svg className={toggle ? "arrow-down-svg" : "arrow-up-svg"} width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path className={toggle ? "" : "arrow-up-svg-color"} d="M0 1.23529L1.23529 0L7.94118 6.70588L14.6471 0L15.8824 1.23529L7.94118 9.17647L0 1.23529Z" fill="#007398" />
                                </svg>
                              </button>
                              <div className={toggle ? "dropdown-container dropdown-container-hidden" : "dropdown-container"}>
                                <div key="all subject Area" className="dropdown-items">
                                  <label className="select-item no-input" htmlFor="no-input">All subject Area</label>
                                  <input onClick={handleChangeSubjectArea} className="dropdwn-option" id="no-input" type="radio" value="" />
                                </div>
                                {subjectAreaArray.map((element) => (
                                  <div key={element} className="dropdown-items">
                                    <label className="select-item" htmlFor={`select-${element}`}>{element}</label>
                                    <input onClick={handleChangeSubjectArea} className="dropdwn-option" id={`select-${element}`} type="radio" value={element} />
                                  </div>
                                ))}
                              </div>
                            </div>
                            {subjectArea !== "" && (
                              <div className="dropdown-main">
                                <button onClick={toggleSubSubjectHidden} className="dropdown-button" id="button">
                                  <span>{subSubjectArea ? subSubjectArea.split(" ")[0] : "All related subject area".substring(0, 15)}</span>
                                  <svg className={toggleSubSubject ? "arrow-down-svg" : "arrow-up-svg"} width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path className={toggleSubSubject ? "" : "arrow-up-svg-color"} d="M0 1.23529L1.23529 0L7.94118 6.70588L14.6471 0L15.8824 1.23529L7.94118 9.17647L0 1.23529Z" fill="#007398" />
                                  </svg>
                                </button>
                                <div className={toggleSubSubject ? "dropdown-container dropdown-container-hidden" : "dropdown-container"}>
                                  {subSubjectAreaArray.map((element) => (
                                    <div key={element} className="dropdown-items">
                                      <label className="select-item" htmlFor={`select-${element} ${element}`}>{element}</label>
                                      <input onClick={handleChangeSubSubjectArea} className="dropdwn-option" id={`select-${element} ${element}`} type="radio" value={element} />
                                    </div>
                                  ))}
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-8 horizontal-container-container">
                      <div className="row horizontal-container">
                        <div className={isAllBooks ? "col-md-4 text-end auto-width" : "col-md-6 text-end auto-width"}>
                          <label> Sort by:</label>
                        </div>
                        <div className="dropdown-main dropdown-horizontal">
                          <button onClick={toggleFiltering} className="dropdown-button" id="button">
                            <span>{filterLabel ? filterLabel : "Sort By"}</span>
                            <svg className={toggleFilter ? "arrow-down-svg" : "arrow-up-svg"} width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path className={toggleFilter ? "" : "arrow-up-svg-color"} d="M0 1.23529L1.23529 0L7.94118 6.70588L14.6471 0L15.8824 1.23529L7.94118 9.17647L0 1.23529Z" fill="#007398" />
                            </svg>
                          </button>
                          <div className={toggleFilter ? "dropdown-container fixed-dropdown dropdown-container-hidden" : "dropdown-container fixed-dropdown"}>
                            <div key="latest" className="dropdown-items">
                              <label className="select-item no-input pointer" htmlFor="Publication(Latest)">Publication(Latest)</label>
                              <input onClick={handleSorting} className="dropdwn-option" id="Publication(Latest)" type="radio" value="year-desc" />
                            </div>
                            <div key="oldest" className="dropdown-items">
                              <label className="select-item no-input pointer" htmlFor="Publication(Oldest)">Publication(Oldest)</label>
                              <input onClick={handleSorting} className="dropdwn-option" id="Publication(Oldest)" type="radio" value="year-asc" />
                            </div>
                            <div key="correct-order" className="dropdown-items">
                              <label className="select-item no-input pointer" htmlFor="Alphabetical(A-Z)">Alphabetical(A-Z)</label>
                              <input onClick={handleSorting} className="dropdwn-option" id="Alphabetical(A-Z)" type="radio" value="title-asc" />
                            </div>
                            <div key="reverse-order" className="dropdown-items">
                              <label className="select-item no-input pointer" htmlFor="Alphabetical(Z-A)">Alphabetical(Z-A)</label>
                              <input onClick={handleSorting} className="dropdwn-option" id="Alphabetical(Z-A)" type="radio" value="title-desc" />
                            </div>
                          </div>
                        </div>
                        {isAllBooks && (
                          <div className="col-md-4">
                            <DownloadXlsFile data={products} />
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  {pageOfItems.map((element) => (
                    <Book key={element.product_id} id={element.product_id} bookDetails={element} checkAndUpdatedCart={props.checkAndUpdatedCart} />
                  ))}
                  <div className="row text-center">
                    <nav aria-label="Pagination" className="es-pagination">
                      <ul className="pagination">
                        <div>
                          <li>
                            <button
                              aria-label="First page"
                              className="es-button-alternative secondary es-js-tooltip"
                              onClick={() => setPage(1)}
                              disabled={pager.currentPage === 1}
                            >
                              <svg className="icon" viewBox="0 0 54 128" height="24" width="17">
                                <path d="m2 16h1e1v9e1h-1e1zm14 45l45-45 7 7-38 38 38 38-7 7z" />
                              </svg>
                            </button>
                          </li>
                          <li>
                            <button
                              aria-label="Previous page"
                              className="es-button-alternative secondary"
                              onClick={() => setPage(pager.currentPage - 1)}
                              disabled={pager.currentPage === 1}
                            >
                              <svg className="icon" viewBox="0 0 54 128" height="24" width="11">
                                <path d="M1 61l45-45 7 7-38 38 38 38-7 7z" />
                              </svg>
                              <span>Previous</span>
                            </button>
                          </li>
                        </div>
                        <div>
                          <li>
                            <span>
                              {pager.currentPage} Page of {pager.totalPages}
                            </span>
                          </li>
                        </div>
                        <div>
                          <li>
                            <button
                              aria-label="Next page"
                              className="es-button-alternative secondary"
                              onClick={() => setPage(pager.currentPage + 1)}
                              disabled={pager.currentPage === pager.totalPages}
                            >
                              <span>Next</span>
                              <svg className="icon" viewBox="0 0 54 128" height="24" width="11">
                                <path d="M1 99l38-38L1 23l7-7 45 45-45 45z" />
                              </svg>
                            </button>
                          </li>
                          <li>
                            <button
                              aria-label="Last page"
                              className="es-button-alternative secondary es-js-tooltip"
                              onClick={() => setPage(pager.totalPages)}
                              disabled={pager.currentPage === pager.totalPages}
                            >
                              <svg className="icon" viewBox="0 0 54 128" height="24" width="17">
                                <path d="m58 16h1e1v9e1h-1e1zm-56 83l38-38-38-38 7-7 45 45-45 45z" />
                              </svg>
                            </button>
                          </li>
                        </div>
                      </ul>
                    </nav>
                  </div>
                </div>
              ) : (
                <div>
                  <h1 className="no-results-found">
                    <svg
                      className="no-results-svg"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 100 128"
                      height="24"
                      width="19"
                    >
                      <path
                        d="M19.22 76.91c-5.84-5.84-9.05-13.6-9.05-21.85s3.21-16.01 9.05-21.85c5.84-5.83 13.59-9.05 21.85-9.05 8.25 0 16.01 3.22 21.84 9.05 5.84 5.84 9.05 13.6 9.05 21.85s-3.21 16.01-9.05 21.85c-5.83 5.83-13.59 9.05-21.84 9.05-8.26 0-16.01-3.22-21.85-9.05zm80.33 29.6L73.23 80.19c5.61-7.15 8.68-15.9 8.68-25.13 0-10.91-4.25-21.17-11.96-28.88-7.72-7.71-17.97-11.96-28.88-11.96S19.9 18.47 12.19 26.18C4.47 33.89.22 44.15.22 55.06s4.25 21.17 11.97 28.88C19.9 91.65 30.16 95.9 41.07 95.9c9.23 0 17.98-3.07 25.13-8.68l26.32 26.32 7.03-7.03"
                      />
                    </svg>
                    No results found. Try another set of filters or keyword
                  </h1>
                </div>
              )}
            </div>
          </div>
        </section>
      </div>
    </React.Fragment>
  );
};

export default AllBookTemplate;